import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import React from 'react';
import { useColorModeValue } from '@chakra-ui/react';

const StatCard = ({
  icon,
  label,
  count,
  bgColor,
  waveColor,
  color,
  onClick,
}) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const cardShadow = useColorModeValue('md', 'dark-lg');
  const labelColor = useColorModeValue('gray.700', 'gray.200');
  const countColor = useColorModeValue('gray.800', 'white');
  const subLabelColor = useColorModeValue('gray.500', 'gray.400');
  const hoverTransform = useColorModeValue('scale(1.02)', 'scale(1.03)');
  return (
    <Box
      p={{ base: 3, md: 4 }}
      borderWidth="1px"
      borderRadius="lg"
      boxShadow={cardShadow}
      position="relative"
      overflow="hidden"
      bg={cardBg}
      minH={{ base: '140px', md: '170px' }}
      onClick={() => {
        onClick?.();
      }}
      _hover={{ transform: hoverTransform, boxShadow: 'lg' }}
      transition="transform 0.4s ease-in-out, box-shadow 0.4s ease-in-out"
      cursor="pointer"
    >
      <Flex
        align="center"
        direction={{ base: 'column', sm: 'row' }}
        gap={{ base: 2, sm: 3 }}
        justify={{ base: 'center', sm: 'flex-start' }}
      >
        <Box
          bg={bgColor}
          p={{ base: 2.5, md: 3 }}
          borderRadius="lg"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon
            as={icon}
            w={{ base: 5, md: 6 }}
            h={{ base: 5, md: 6 }}
            color={color}
          />
        </Box>
        <Text
          fontWeight="bold"
          fontSize={{ base: 'md', md: 'lg' }}
          color={labelColor}
          textAlign={{ base: 'center', sm: 'left' }}
        >
          {label}
        </Text>
      </Flex>

      <Box mt={{ base: 3, md: 4 }} textAlign={{ base: 'center', sm: 'left' }}>
        <Text
          fontSize={{ base: '2xl', md: '3xl' }}
          fontWeight="bold"
          color={countColor}
        >
          {count}
        </Text>
        <Text fontSize={{ base: 'xs', md: 'sm' }} color={subLabelColor}>
          {label}
        </Text>
      </Box>

      <Box
        position="absolute"
        bottom="0"
        left="0"
        width="100%"
        height="60px"
        background={`linear-gradient(to top, ${waveColor}30, transparent)`}
        borderBottomRadius="lg"
        pointerEvents="none"
      />
    </Box>
  );
};

function arePropsEqual(prevProps, nextProps) {
  return (
    prevProps.label === nextProps.label &&
    prevProps.count === nextProps.count &&
    prevProps.bgColor === nextProps.bgColor &&
    prevProps.waveColor === nextProps.waveColor &&
    prevProps.color === nextProps.color &&
    prevProps.icon === nextProps.icon &&
    prevProps.onClick === nextProps.onClick
  );
}

export default StatCard;
